import { render, staticRenderFns } from "./WholesalerPlatformPricemarkdownComponent.vue?vue&type=template&id=3053ff99&"
import script from "./WholesalerPlatformPricemarkdownComponent.vue?vue&type=script&lang=js&"
export * from "./WholesalerPlatformPricemarkdownComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports